<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCardHeader class="p-1">
                    <CRow>
                        <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">

                            <strong>{{$t('DataEntry')}}</strong>

                        </CCol>
                        <CCol col="4" style="text-align: end">

                            <CButton v-if="items.length>0" @click="send_data()" size="sm"
                                     color="secondary"
                                     class="mr-1">
                                {{ $t('save') }}
                            </CButton>
                        </CCol>
                    </CRow>
                </CCardHeader>
            </CCol>
        </CRow>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                <strong>{{$t('Personals')}}</strong>
                            </CCol>
                        </CRow>
                    </CCardHeader>

                    <CCardBody>
                        <CRow>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="get_template(1)"
                                        color="secondary">{{ $t("Template") }}
                                </CButton>
                            </CCol>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="open_file_selector(1)"
                                        color="secondary">{{ $t("Convert") }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>

            <CCol >
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                <strong>{{$t('items')}}</strong>
                            </CCol>
                        </CRow>
                    </CCardHeader>

                    <CCardBody>
                        <CRow>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="get_template(4)"
                                        color="secondary">{{ $t("Template") }}
                                </CButton>
                            </CCol>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="open_file_selector(4)"
                                        color="secondary">{{ $t("Convert") }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol >
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                <strong>{{$t('Customers')}}</strong>
                            </CCol>
                        </CRow>
                    </CCardHeader>

                    <CCardBody>
                        <CRow>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="get_template(2)"
                                        color="secondary">{{ $t("Template") }}
                                </CButton>
                            </CCol>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="open_file_selector(2)"
                                        color="secondary">{{ $t("Convert") }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol >
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                <strong>{{$t('Suppliers')}}</strong>
                            </CCol>
                        </CRow>
                    </CCardHeader>

                    <CCardBody>
                        <CRow>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="get_template(3)"
                                        color="secondary">{{ $t("Template") }}
                                </CButton>
                            </CCol>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="open_file_selector(3)"
                                        color="secondary">{{ $t("Convert") }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol >
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                <strong>{{$t('TrialBalance')}}</strong>
                            </CCol>
                        </CRow>
                    </CCardHeader>

                    <CCardBody>
                        <CRow>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="get_template(5)"
                                        color="secondary">{{ $t("Template") }}
                                </CButton>
                            </CCol>
                            <CCol>
                                <CButton
                                        size="sm"
                                        class="m-1"
                                        @click="open_file_selector(5)"
                                        color="secondary">{{ $t("Convert") }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>

        </CRow>

        <CInputFile

                ref="file_selector"
                v-show="false"
                v-on:change="handleFileUpload"
        />
        <CCol col="12" v-if="items.length>0">
            <CDataTableFixed
                    :items="items"
                    :fields="fields"
                    column-filter
                    height="350px"
                    hover
                    sorter
                    border
                    striped
                    :sorter-value="{column:'id',asc:false}"
            >

            </CDataTableFixed>

        </CCol>
    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';

    var items = [];

    import Vue from "vue";
    import JsonExcel from "vue-excel-ultra";
    import readXlsxFile from 'read-excel-file'

    Vue.component("downloadExcel", JsonExcel);
    export default {
        name: 'Login',
        components: {},
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                name: '',
                file: null,
                export_file_name: '',
                export_modal: false,
                json_data: [],
                items: [],
                fields: [],
                status_form: 0,
                selected_file_type: 0,
            }
        }, mounted() {
            this.$root.root_validate_errors = [];

        }, watch: {},
        methods: {

            get_template(type) {
                var self = this;
                const formData = new FormData();
                var url = "JournalDataExport";
                formData.append("Id", type);
                axios.post(url, formData, {responseType: 'blob'}).then(function (response) {

                    // var content_data = response.data;
                    const href = URL.createObjectURL(response.data);

                    // create "a" HTML element with href to file & click
                    const link = document.createElement('a');
                    link.href = href;
                    var file_name = "file.xlsx"
                  if (type == 1) {
                    file_name = "Personnel.xlsx"
                  }
                  if (type == 2) {
                    file_name = "Customers.xlsx"
                  }
                  if (type == 3) {//09390957847
                    file_name = "Suppliers.xlsx"
                  }
                  if (type == 4) {
                    file_name = "Items.xlsx"
                  }
                   if (type == 5) {
                        file_name = "Trial Balance.xlsx"
                    }

                    link.setAttribute('download', file_name); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                    // items = content_cats.orders;
                    // if (content_data.statusCode == 0) {
                    //   self.export_file_name="Users.xls"
                    //
                    //   self.export_modal = true;
                    //   self.json_data = [];
                    //
                    //     self.json_data = response.data.data
                    //     self.export_modal = true;
                    //     setTimeout(function () {
                    //       document.getElementById("download_json_template").click()
                    //
                    //     },300)
                    //
                    // } else {
                    //   self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    //
                    // }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            send_data() {
                var self = this;
                const formData = new FormData();
                var url = "JournalDataImport";
                formData.append("Id", this.selected_file_type);
                formData.append("items", JSON.stringify(this.items));
                axios.post(url, formData, {}).then(function (response) {

                    // var content_data = response.data;
                    self.$root.modal_component.show_api_response_modals(response);

                    // if (content_data.statusCode == 0) {
                    //
                    //
                    // } else {
                    //   self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    //
                    // }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            open_file_selector(type) {
                this.selected_file_type = type
                this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
            },
            handleFileUpload(files, e) {
                console.log("handle upload")
                this.file = e.target.files[0];
                this.read_ecel()

                // this.previewImage = URL.createObjectURL(this.file);
                // e.target.value = '';
                // e.target.files = '';
            },
            read_ecel() {
                try {
                    if (this.file) {
                        var input = this.$refs.file_selector.$el.getElementsByTagName('input')[0]
                        readXlsxFile(input.files[0]).then((rows) => {
                            // `rows` is an array of rows
                            self.fields = []
                            self.items = []
                            if (rows.length > 0) {
                                for (var i = 0; i < rows.length; i++) {
                                    var row = rows[i];
                                    if (i == 0) {
                                        row.forEach(function (val, index) {
                                            self.fields.push({label: val, key: val})
                                        })
                                    } else {
                                        var item = {};
                                        row.forEach(function (val, index) {
                                            item[rows[0][index]] = val
                                        })
                                        self.items.push(item)
                                    }


                                }

                            }

                            // each row being an array of cells.
                        }).catch((rows) => {
                            alert('Invalid File')
                        })
                    }

                } catch (e) {
                    alert('Invalid File');
                }
                var self = this

            },
            insert_data() {


                if (!this.validateForm()) {
                    // console.log("validate form is false"+this.validate_errors);
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddMainCat";
                } else {
                    url = "EditMainCat";
                    formData.append('id', this.status_form)

                }

                formData.append('file', this.file);
                formData.append('MainCatTitle', this.name);
                formData.append('Color', this.color);
                formData.append('Code', this.code);
                if (this.$route.params.cat_id != null) {
                    formData.append('IsParent', this.$route.params.cat_id);

                } else {
                    formData.append('IsParent', 0);

                }
                formData.append('summary', this.description);
                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;
                    self.name = '';
                    self.color = '#ffffff';
                    self.code = '';
                    self.description = '';
                    self.previewImage = '/img/placeholder.png';
                    self.get_lists();


                })

                    // axios.post(  '/admin/category', {
                    //     name: self.name,
                    //     description: self.description,
                    //     image: self.image,
                    //     cat: 0,
                    // }).then(function (response) {
                    //     self.name = '';
                    //     self.description = '';
                    //     // localStorage.setItem("api_token", response.data.access_token);
                    //     // self.$router.push({ path: 'notes' });
                    // })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

        }
    }

</script>
